import RouterView from '@/components/RouterView'
const routes = [

  {
    path: '/doc',
    component: RouterView,
    children: [
      {
        path: '', // 匹配 /doc
        component: () => import('@/views/doc/index.vue'),
      },
      {
        path: ':id', // 匹配 /doc/:id
        component: () => import('@/views/doc/index.vue'),
      }
    ]
  }
];

export default routes;
